import { IAccordionItemProps } from '@cian/ui-kit';

export const FAQ: IAccordionItemProps[] = [
  {
    title: 'Как работает гарантия безопасности сделки?',
    content: (
      <div style={{ maxWidth: '720px', color: 'var(--icon-primary-default)' }}>
        Юрист, специализирующийся на недвижимости, проверит документы на квартиру, оценит риски и подготовит отчёт.
        <br />
        <br />
        Если в течение трёх лет после сделки ваше право собственности на объект окажется под угрозой, юрист будет
        защищать ваши интересы в суде. В случае потери права собственности вы получите возврат полной стоимости объекта.
      </div>
    ),
  },
  {
    title: 'Сколько стоят ваши услуги?',
    content: (
      <div style={{ maxWidth: '720px', color: 'var(--icon-primary-default)' }}>
        Наши услуги бесплатны. Оплатить будет нужно только работу риелтора и только после успешного завершения сделки и
        перехода права собственности к вам.
        <br />
        <br />
        Средняя комиссия — 1,5–2,5% от стоимости. Комиссия может быть и больше (для загородной недвижимости), и меньше
        (если вам понадобится только часть услуг).
      </div>
    ),
  },
  {
    title: 'Откуда мне знать, что риелтор — и правда профессионал?',
    content: (
      <div style={{ maxWidth: '720px', color: 'var(--icon-primary-default)' }}>
        В сервисе с вами будут работать только наши партнёры — проверенные агентства недвижимости с хорошим рейтингом и
        отзывами
      </div>
    ),
  },
  {
    title: 'Я смогу выбрать риелтора из вашего списка самостоятельно?',
    content: (
      <div style={{ maxWidth: '720px', color: 'var(--icon-primary-default)' }}>
        Нет, после консультации мы выберем для вас специалиста с самым подходящим опытом, который ориентируется в нужном
        районе. Если вдруг отношения с этим агентом у вас не сложатся — обратитесь к нам, и мы подберём другого.
      </div>
    ),
  },
  {
    title: 'Что делать, если мне не понравится риелтор?',
    content: (
      <div style={{ maxWidth: '720px', color: 'var(--icon-primary-default)' }}>
        По любым вопросам вы сможете обратиться к нам и мы подключимся, чтобы помочь и подобрать другого специалиста
      </div>
    ),
  },
  {
    title: 'Риелтор поможет с документами и проверкой продавца?',
    content: (
      <div style={{ maxWidth: '720px', color: 'var(--icon-primary-default)' }}>
        Риелтор поможет на каждом этапе, в том числе с оформлением и проверкой документов и продавца, а также сопроводит
        вас на самой сделке
      </div>
    ),
  },
  {
    title: 'Жильё уже нашлось — поможете юридически?',
    content: (
      <div style={{ maxWidth: '720px', color: 'var(--icon-primary-default)' }}>
        Да, если вы уже выбрали жильё, мы подберем агента, который поможет на финальном этапе: проверит объект,
        подготовит документы и проведёт юридическое сопровождение сделки, чтобы все прошло безопасно
      </div>
    ),
  },
];
